import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";
import { fetchMouleSelectionPrivacy } from "../AirlineImages/FetchModule";
import { fetchPrivacyPolicySelection } from "../ShopAndDine/FetchDropdownApi";

export const getPrivacyPolicyDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  privacyPolicyTabOne: [
    {
      fieldName: "Tab Title ID",
      fieldValue: "parent_id_1",
      className: "col-span-6",
      type: "select",
      name: "parent_id_1",
      formType: "select",
      label: "Tab Title ID",
      placeholder: "Enter Tab Title ID",
      loadOptions: fetchPrivacyPolicySelection,
      validation: { required: "Tab Title ID is required" },
    },
    {
      fieldName: "Title",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title",
      placeholder: "Enter Title",
      validation: { required: "Title is required" },
    },
    {
      fieldName: "Description",
      fieldValue: "description",
      className: "col-span-6",
      type: "textarea",
      name: "description",
      formType: "richText",
      label: "Description",
      placeholder: "Enter Description",
      validation: { required: "Description is required" },
    },
    // {
    //   fieldName: "Parent ID",
    //   fieldValue: "parent_id",
    //   className: "col-span-6",
    //   type: "select",
    //   name: "parent_id",
    //   formType: "select",
    //   label: "Parent ID",
    //   placeholder: "Enter Parent ID",
    //   validation: { required: "Parent ID is required" },
    //   loadOptions: fetchPrivacyPolicySelection,
    // },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Select if published",
    },
  ],
  privacyPolicyTabTwo: [
    {
      fieldName: "Title",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title",
      placeholder: "Enter Title",
      validation: { required: "Title is required" },
    },
    {
      fieldName: "Description",
      fieldValue: "description",
      className: "col-span-6",
      type: "textarea",
      name: "description",
      formType: "richText",
      label: "Description",
      placeholder: "Enter Description",
      validation: { required: "Description is required" },
    },
    {
      fieldName: "Section",
      fieldValue: "section",
      className: "col-span-6",
      type: "text",
      name: "section",
      formType: "input",
      label: "Section",
      placeholder: "Enter Section (Ex: tab2)",
      // validation: { required: "Section is required" },
    },
    {
      fieldName: "Parent ID",
      fieldValue: "parent_id",
      className: "col-span-6",
      type: "select",
      name: "parent_id",
      formType: "select",
      label: "Parent ID",
      placeholder: "Enter Parent ID",
      loadOptions: fetchPrivacyPolicySelection,
      validation: { required: "Parent ID is required" },
    },
    {
      fieldName: "parenttest",
      fieldValue: "parent_id_1",
      className: "col-span-6",
      type: "select",
      name: "parent_id_1",
      formType: "select",
      label: "Category",
      placeholder: "Enter Category",
      loadOptions: fetchPrivacyPolicySelection,
      validation: { required: "Category is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Select if published",
    },
  ],
  myAirportsPrivacyPolicy: [
    {
      fieldName: "Tab 1 Title (EN)",
      fieldValue: "tab_title_english_1",
      className: "col-span-6",
      type: "text",
      name: "tab_title_english_1",
      formType: "input",
      label: "Tab 1 Title (EN)",
      placeholder: "Enter Tab 1 Title (EN)",
      validation: { required: "Tab 1 Title (EN) is required" },
    },
    {
      fieldName: "Tab 1 Title (MS)",
      fieldValue: "tab_title_malay_1",
      className: "col-span-6",
      type: "text",
      name: "tab_title_malay_1",
      formType: "input",
      label: "Tab 1 Title (MS)",
      placeholder: "Enter Tab 1 Title (MS)",
    },
    {
      fieldName: "Tab 1 Title (ZH)",
      fieldValue: "tab_title_mandarin_1",
      className: "col-span-6",
      type: "text",
      name: "tab_title_mandarin_1",
      formType: "input",
      label: "Tab 1 Title (ZH)",
      placeholder: "Enter Tab 1 Title (ZH)",
    },
    {
      fieldName: "Tab 2 Title (EN)",
      fieldValue: "tab_title_english_2",
      className: "col-span-6",
      type: "text",
      name: "tab_title_english_2",
      formType: "input",
      label: "Tab 2 Title (EN)",
      placeholder: "Enter Tab 2 Title (EN)",
      validation: { required: "Tab 2 Title (EN) is required" },
    },
    {
      fieldName: "Tab 2 Title (MS)",
      fieldValue: "tab_title_malay_2",
      className: "col-span-6",
      type: "text",
      name: "tab_title_malay_2",
      formType: "input",
      label: "Tab 2 Title (MS)",
      placeholder: "Enter Tab 2 Title (MS)",
    },
    {
      fieldName: "Tab 2 Title (ZH)",
      fieldValue: "tab_title_mandarin_2",
      className: "col-span-6",
      type: "text",
      name: "tab_title_mandarin_2",
      formType: "input",
      label: "Tab 2 Title (ZH)",
      placeholder: "Enter Tab 2 Title (ZH)",
    },
    {
      fieldName: "Description Tab 1 (EN)",
      fieldValue: "description_english_tab_1",
      className: "col-span-6",
      type: "textarea",
      name: "description_english_tab_1",
      formType: "richText",
      label: "Description Tab 1 (EN)",
      placeholder: "Enter Description Tab 1 (EN)",
      validation: { required: "Description Tab 1 (EN) is required" },
    },
    {
      fieldName: "Description Tab 1 (MS)",
      fieldValue: "description_malay_tab_1",
      className: "col-span-6",
      type: "textarea",
      name: "description_malay_tab_1",
      formType: "richText",
      label: "Description Tab 1 (MS)",
      placeholder: "Enter Description Tab 1 (MS)",
      // validation: { required: "Description Tab 1 (MS) is required" },
    },
    {
      fieldName: "Description Tab 1 (ZH)",
      fieldValue: "description_mandarin_tab_1",
      className: "col-span-6",
      type: "textarea",
      name: "description_mandarin_tab_1",
      formType: "richText",
      label: "Description Tab 1 (ZH)",
      placeholder: "Enter Description Tab 1 (ZH)",
      // validation: { required: "Description Tab 1 (ZH) is required" },
    },
    {
      fieldName: "Description Tab 2 (EN)",
      fieldValue: "description_english_tab_2",
      className: "col-span-6",
      type: "textarea",
      name: "description_english_tab_2",
      formType: "richText",
      label: "Description Tab 2 (EN)",
      placeholder: "Enter Description Tab 2 (EN)",
      validation: { required: "Description Tab 2 (EN) is required" },
    },
    {
      fieldName: "Description Tab 2 (MS)",
      fieldValue: "description_malay_tab_2",
      className: "col-span-6",
      type: "textarea",
      name: "description_malay_tab_2",
      formType: "richText",
      label: "Description Tab 2 (MS)",
      placeholder: "Enter Description Tab 2 (MS)",
      // validation: { required: "Description Tab 2 (MS) is required" },
    },
    {
      fieldName: "Description Tab 2 (ZH)",
      fieldValue: "description_mandarin_tab_2",
      className: "col-span-6",
      type: "textarea",
      name: "description_mandarin_tab_2",
      formType: "richText",
      label: "Description Tab 2 (ZH)",
      placeholder: "Enter Description Tab 2 (ZH)",
      // validation: { required: "Description Tab 2 (ZH) is required" },
    },
  ],

  TabOneData: [
    {
      fieldName: "Modules / Airports",
      fieldValue: "project_airport_id_1",
      className: "col-span-6",
      type: "select",
      name: "project_airport_id_1",
      formType: "multiSelect",
      label: "Modules / Airports",
      placeholder: "Enter Modules / Airports",
      validation: { required: "Modules / Airports is required" },
      loadOptions: fetchMouleSelectionPrivacy,
    },
    {
      fieldName: "Tab Title (EN)",
      fieldValue: "tab_title_english",
      className: "col-span-6",
      type: "text",
      name: "tab_title_english",
      formType: "input",
      label: "Tab Title (EN)",
      placeholder: "Enter Tab Title (EN)",
      validation: { required: "Tab Title (EN) is required" },
    },
    {
      fieldName: "Tab Title (MS)",
      fieldValue: "tab_title_malay",
      className: "col-span-6",
      type: "text",
      name: "tab_title_malay",
      formType: "input",
      label: "Tab Title (MS)",
      placeholder: "Enter Tab Title (MS)",
    },
    {
      fieldName: "Tab Title (ZH)",
      fieldValue: "tab_title_mandarin",
      className: "col-span-6",
      type: "text",
      name: "tab_title_mandarin",
      formType: "input",
      label: "Tab Title (ZH)",
      placeholder: "Enter Tab Title (ZH)",
    },
    {
      fieldName: "PDF",
      fieldValue: "pdf_url",
      className: "col-span-6",
      usedFileType: ".pdf",
      type: "pdf",
      name: "pdf_url",
      formType: "file",
      label: "PDF",
      placeholder: "Enter PDF",
      note: "The PDF field is applicable only for My Airports, while all other fields are for the Corporate website.",
      validation: { required: "PDF is Required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Select if published",
    },
  ],

  TabTwoData: [
    {
      fieldName: "Tab Title (English)",
      fieldValue: "tab_title_english",
      className: "col-span-6",
      type: "text",
      name: "tab_title_english",
      formType: "input",
      label: "Tab Title (English)",
      placeholder: "Enter Tab Title (English)",
      validation: { required: "Tab Title (English) is required" },
    },
    {
      fieldName: "Tab Title (Malay)",
      fieldValue: "tab_title_malay",
      className: "col-span-6",
      type: "text",
      name: "tab_title_malay",
      formType: "input",
      label: "Tab Title (Malay)",
      placeholder: "Enter Tab Title (Malay)",
    },
    {
      fieldName: "Tab Title (Mandarin)",
      fieldValue: "tab_title_mandarin",
      className: "col-span-6",
      type: "text",
      name: "tab_title_mandarin",
      formType: "input",
      label: "Tab Title (Mandarin)",
      placeholder: "Enter Tab Title (Mandarin)",
    },
    // {
    //   fieldName: "Body",
    //   fieldValue: "body",
    //   className: "col-span-12",
    //   type: "textarea",
    //   name: "body",
    //   formType: "richText",
    //   label: "Body",
    //   placeholder: "Enter Body",
    //   validation: { required: "Body is required" },
    // },
  ],
};
